import { inject, Injectable, Injector } from '@angular/core';

import { createProviderToken, provide } from '@core/common-legacy';
import { HttpApiService } from '@core/http-legacy';
import { HttpApiRequestOptions, HttpRequestData } from '@core/http-types';
import { TellentAdminRequestData } from '@core/tellent-http-legacy';

@Injectable()
export class TellentGettingStartedRequestData extends TellentAdminRequestData {
  public buildUrl(path: string, requestOptions: HttpApiRequestOptions): string {
    return `${this.config.tellentApiUrl}${
      requestOptions.skipCompany ? '' : '/getting-started/org/' + this.orgGuid
    }${path}`;
  }
}

export const { inject: injectTellentGettingStartedHttp } = createProviderToken<HttpApiService>(
  'TellentGettingStartedHttp',
)(false, {
  providedIn: 'root',
  factory: () =>
    Injector.create({
      providers: [
        provide(HttpApiService, { useClass: HttpApiService }),
        provide(HttpRequestData, { useClass: TellentGettingStartedRequestData }),
      ],
      parent: inject(Injector),
    }).get(HttpApiService),
});
